import React from "react";
import {GridCell, gridConstants, GridContainer, GridFlexSpacer} from "../Grid";

interface LayoutMediumProps {
    children?: React.ReactNode;
    className?: string;
}

export const LayoutMedium: React.FC<LayoutMediumProps> = ({children, className}: LayoutMediumProps) => {
    return (
        <GridContainer>
            <GridFlexSpacer/>
            <GridCell
                className={className}
                medium_columns={gridConstants.column.TEN}
                large_columns={gridConstants.column.EIGHT}
            >
                {children}
            </GridCell>
            <GridFlexSpacer/>
        </GridContainer>
    );
};
